import http from '@/base/api/public'
let apiUrl = require('@/../config/sysConfig')
import querystring from 'querystring'

// tab1检索处理
export const s0001Tab1_search = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet('api/v1/shiftInfo' + '?' + querys)
}
// tab1更新处理
export const s0001Tab1_update = (params) => {
    return http.requestPost('api/v1/shiftInfo', params)
}
// tab2检索处理
export const s0001Tab2_search = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet('api/v1/crewInfo' + '?' + querys)
}
// tab2更新处理
export const s0001Tab2_update = (params) => {
    return http.requestPost('api/v1/crewInfo', params)
}
//tab3 检索处理 勤務実績情報検索
export const s0001Tab3_search = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet('api/v1/attendenceInfo' + '?' + querys)
}
//tab3 检索处理 勤怠詳細情報検索
export const s0001Tab3_detail_search = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet('api/v1/attendenceDetailInfo' + '?' + querys)
}


// WEBPACK FOOTER //
// ./src/module/api/s_0001.js